import React, { useState, useEffect } from 'react'
import useSubscriptions from '../../hooks/useSubscriptions';
import useSubscriptionWatcher from '../../hooks/useSubscriptionWatcher';
import SecureLS from "secure-ls";
import { useSelector, useDispatch } from "react-redux";
import { saveServiceProvider } from '../../Actions/serviceProvider';
import { SERVICEPROVIDER } from '../../Constants/localStorageKeys';
import { showGlobalMessage, updateGlobalMessage } from '../../Actions/messageAlert';
import { Modal } from 'react-bootstrap';
import MembeshipItems from '../Organisms/WorkFlow/MembeshipItems';
import PricingTable from '../Organisms/PricingTable';

const SubscriptionInformation = ({ userEmail, upgrade = false }) => {

    const token = useSelector((state) => state.token.token);
    const dispatch = useDispatch();
    const [paymentProgress, setPaymentProgress] = useState(false);
    const [showSubscriptionWall, setShowSubscriptionWall] = useState(false);
    const [showDemoAlert, setShowDemoAlert] = useState(false);

    const { subscription, getSubscription } = useSubscriptions(token);

    useSubscriptionWatcher({
        paymentProgress,
        getSubscription: getSubscription,
        findCont: false
    });

    useEffect(() => {
        if (subscription?.status === "active" && paymentProgress && subscription) {
            let ls = new SecureLS();
            let user = ls.get(SERVICEPROVIDER);
            user.subscription = subscription;
            dispatch(saveServiceProvider(user));
            dispatch(showGlobalMessage(true));
            dispatch(updateGlobalMessage("You're all set! Your payment went through successfully, and you can now enjoy all the perks of your Basic Membership."));
            ls.set(SERVICEPROVIDER, user);
            setPaymentProgress(false);
        }
    }, [subscription])

    const handleActivePaymentProgress = () => {

        setPaymentProgress(true);
        window.open('https://buy.stripe.com/test_7sIdTocj02dU0qkeUZ?prefilled_email=' + userEmail, '_blank');
    }

    return (
        <>
            <Modal show={showSubscriptionWall} size="lg" centered onHide={() => setShowSubscriptionWall(false)} style={{ backgroundColor: "#000000c7", zIndex: "2000" }}>
                <Modal.Body className='m-0 p-0'>
                    <div className="modal-card-head"><span onClick={() => setShowSubscriptionWall(false)} style={{ cursor: 'pointer' }}>X</span></div>
                    {showDemoAlert &&
                        <div className='alert alert-warning m-0'>
                            This category is not available in trial mode. Please sign in or sign up to access it.
                        </div>
                    }

                    <section className={"modal-card-body membership-modal radius-0"}>
                        <PricingTable currentPlan={'Free'} token={token} email={userEmail} origin={'dashboard'} handleActivePaymentProgress={handleActivePaymentProgress} />
                        {/* <MembeshipItems handleShowModalEntrance={() => { }} handleActivePaymentProgress={handleActivePaymentProgress} subscription={'free'} /> */}
                    </section>
                </Modal.Body>
            </Modal>
            <div className='text-center' style={{ marginTop: '8vh', padding: '15px', backgroundColor: '#e7e7e7', borderRadius: '5px' }}>
                <p style={{ fontSize: '15px', fontWeight: '700', fontFamily: 'Inter, serif' }}>
                    Unlock  Cloud Editing <br></br>& Beta Tools
                </p>
                <p style={{ fontSize: '15px', fontWeight: '500', fontFamily: 'Inter, serif' }}>
                    Edit your framework's table of content in the cloud, and access exclusive beta features.
                </p>
                <p style={{ fontSize: '15px', fontWeight: '500' }}>
                    Basic plan is only $24.95/Mo
                </p>

                <button
                    className='w-100 mt-2'
                    style={{ backgroundColor: '#fcc75c', padding: '5px', borderRadius: '5px', border: '0px', color: "#d2691e", fontWeight: '800', fontSize: '18px' }}
                    // onClick={() => { handleActivePaymentProgress() }}
                    onClick={()=>{setShowSubscriptionWall(true)}}
                >Join Basic</button>
            </div>
        </>
    )
}

export default SubscriptionInformation